var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("span", { staticClass: "mr-1.5" }, [_vm._v(_vm._s(_vm.notification))]),
      _c("TabNotificationBubble", {
        attrs: { notification: _vm.tabNotification, info: "" },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }